module.exports = __webpack_public_path__ + "static/media/Frowning.4558cbc9.png";